import { schema } from "./attribute-schema";

export const inputs = [
  {
    id: "description",
    title: "Description",
    input: {
      type: "TextAreaField"
    }
  },

  {
    id: "serviceOwner",
    title: "Service Owner",
    input: {
      type: "TextField"
    }
  },

  {
    id: "businessUnit",
    title: "Business Unit",
    input: {
      type: "TextField"
    }
  },

  {
    id: "servingURL",
    title: "Serving URL",
    input: {
      type: "TextField"
    }
  },

  {
    id: "location",
    title: "Location",
    input: {
      type: "TextField"
    }
  },

  {
    id: "platform",
    title: "Platform",
    input: {
      type: "TextField"
    }
  },

  {
    id: "hipchatRoomName",
    title: "HipChat Room Name",
    input: {
      type: "TextField"
    }
  },

  {
    id: "pagerdutyServiceID",
    title: "Pagerduty Service ID",
    input: {
      type: "TextField"
    }
  },

  {
    id: "team",
    title: "Team",
    input: {
      type: "TextField"
    }
  },

  {
    id: "serviceTier",
    title: "Service Tier",
    input: {
      type: "SelectField",
      names: schema.properties.serviceTier.enum.map(v => `Tier ${v}`),
      values: schema.properties.serviceTier.enum
    }
  }

  // {
  //   id:    'compliancePolicyId',
  //   title: 'Compliance Policy ID',
  //   input: {
  //     type: 'TextField'
  //   }
  // }
];
